export const isEmpty = (value: any) => {
  return value === null || value === undefined || value === "";
};

export const replaceOrDefault = (
  text: string,
  replace: string,
  value: string
) => {
  return value !== undefined ? text.replace(replace, value) : text;
};

export const capitalize = (s: string) => {
  if (typeof s !== "string") {
    return "";
  }

  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
};

export const regularExpressionCharacters = (num: number) => {
  if (isEmpty(num)) {
    return "";
  }

  return num.toString().replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "");
};

export const stripCommas = (s: number) => s && s.toString().replace(/,/g, "");

export const numberWithCommas = (x: number) => {
  if (isNaN(+x)) {
    return 0;
  }

  return (+x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const maskEmail = (email = "") => {
  return email.replace(
    /^(.)(.*)(.@.*)$/,
    (_, a, b, c) => a + b.replace(/./g, "*") + c
  );
};

export function tryParse<T>(json: string, defaultValue: T) {
  try {
    return JSON.parse(json);
  } catch (ex) {
    return defaultValue;
  }
};
